<template>
  <Card
    v-if="isActive"
    tag="form"
    theme="flat"
    class="shop-floorplan-dialog-mutate-marker"
    @submit.prevent="$emit('submit')"
  >
    <template #default>
      <Leaflet
        v-if="value.image"
        v-model="value.data"
        :image="value.image.url"
        :id-resolver="idResolver"
        :getStyle="getStyle"
        @add="add"
      />
    </template>
    <template #footer>
      <slot name="navigation" />
    </template>
  </Card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { i18n } from '@/i18n'
import Hash from 'object-hash'

import Card from '@/components/Card'
import Leaflet from '@/components/Leaflet'
import { InputComponent } from 'vue-elder-input'

const meta = {
  order: 3,
  id: 'theme',
  label: i18n.t('mark'),
  icon: ['fal', 'palette'],
}

export { meta }
export default {
  props: {
    selected: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  computed: {
    value: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('update:selected', val)
      },
    },
  },
  methods: {
    add(layer) {
      this.value.data.push(layer)
    },
    getStyle() {
      let primary = getComputedStyle(document.documentElement).getPropertyValue('--primary')
      return {
        fillColor: primary,
        fillOpacity: 0.1,
        color: primary,
      }
    },
    idResolver(item) {
      return Hash(item.geometry.coordinates)
    },
  },
  components: {
    Card,
    InputComponent,
    Leaflet,
  },
}
</script>

<style lang="scss">
.shop-floorplan-dialog-mutate-marker {
  max-width: 1000px;
  margin: 0 auto;

  .leaflet__aspect {
    max-height: 60vh;
  }
}
</style>
